module.exports = __webpack_public_path__ + "img/生物制药_01.6a2191ed.png";